import ManTechCarComponent from 'components/marketingSite/mantechcar24/ManTechCar';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Script from 'next/script';
import { ServiceServicePublicStats } from 'services/service.public-stats';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type ManTechCar24PageProps = WithBaseUrl & { manfreditesCount: number };

const ManTechCar24Page: React.FC<ManTechCar24PageProps> = ({
  baseUrl,
  manfreditesCount
}) => {
  const { t } = useI18n('developer-career-report-2024');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('mantechcar24.page_title')}
        url={APP_URLS.mantechcar24}
        desc={t('mantechcar24.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_developer_career_report_2024.png'
        )}`}
        indexable={true}
      />
      <Script
        id="devCareerReportLD"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
  "@context": "https://schema.org",
  "@type": "Report",
  "name": "${t('mantechcar24.page_title')}",
  "url": "https://www.getmanfred.com/developer-career-report",
  "description": "${t('mantechcar24.page_description')}",
  "author": {
    "@type": "Organization",
    "name": "Get Manfred",
    "url": "https://www.getmanfred.com",
    "logo": {
      "@type": "ImageObject",
       "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",
    }
  },
  "publisher": {
    "@type": "Organization",
    "name": "Manfred",
    "url": "https://www.getmanfred.com"
  },
  "datePublished": "2024-11-04",
  "mainEntityOfPage": "https://www.getmanfred.com/developer-career-report",
  "articleSection": "Carrera de Desarrolladores, Oportunidades en IT, Tendencias del Sector"
}`
        }}
      />
      <ManTechCarComponent manfreditesCount={manfreditesCount} />
    </>
  );
};

export default ManTechCar24Page;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const { manfreditesCount } = await ServiceServicePublicStats.get();

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'developer-career-report-2024'
      ])),
      baseUrl: config.appUrl,
      manfreditesCount
    },
    revalidate: 30
  };
};
